import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import "../node_modules/normalize.css/normalize.css"
import "@/assets/scss/app.scss"
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//import "vue-slim-tabs/vue-slim-tabs.css";
import swal from 'sweetalert';
import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);
Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.$cookies.config('7d');

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
